module.exports = __webpack_public_path__ + "img/goat-milk.dfba3675.webp";